import { gql } from '@apollo/client';

export const ParagraphInfolinoFeedbackFormularFragment = gql`
  fragment ParagraphInfolinoFeedbackFormularFragment on ParagraphInfolinoFeedbackFormular {
    id
    email
    ratingCategories
  }
`;
